import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const ContractService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.CONTRACT, null, wait).then((data) => {
            callback(data);
        });
    },
}; 